module.exports = __webpack_public_path__ + "static/img/eye-cream-01.b251f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/eye-cream-01.jpg
// module id = 268
// module chunks = 1